<template>
  <div class="spl-edit-template__step spl-consolidated-container">
    <!-- *********************** Create Containers by Weight & amount  *********************************** -->
    <h4>Create containers by Weight ( &amp; Volume)</h4>
    <div class="row">
      <div class="col2">
        <form-label>Number of Containers</form-label>
        <form-input
          v-model="creationNumContainers"
          :invalid="$v.creationNumContainers.$error && !$v.creationNumContainers.integer"
          class="spl-consolidated-container__container-number"
          placeholder="Containers (pieces)"
          @blur="$v.creationNumContainers.$touch()" />
        <span v-if="$v.creationNumContainers.$error && !$v.creationNumContainers.integer" class="error">Number of Containers must be a number</span>
      </div>
      <div class="col2">
        <form-label>Volume Sum (optional)</form-label>
        <form-input
          v-model="creationVolume"
          :invalid="$v.creationVolume.$error && !$v.creationVolume.decimal"
          type="float"
          class="spl-consolidated-container__sum-volume"
          placeholder="Volume (m3)"
          @blur="$v.creationVolume.$touch()" />
        <span v-if="$v.creationVolume.$error && !$v.creationVolume.integer" class="error">Volume must be a number</span>
      </div>
      <div class="col2">
        <form-label>Weight Sum</form-label>
        <form-input
          v-model="creationWeight"
          :invalid="$v.creationWeight.$error && !$v.creationWeight.decimal"
          type="float"
          class="spl-consolidated-container__sum-weight"
          placeholder="Weight (kg)"
          @blur="$v.creationWeight.$touch()" />
        <span v-if="$v.creationWeight.$error && !$v.creationWeight.integer" class="error">Volume must be a number</span>
      </div>
      <div class="col2">
        <form-label>Loading List</form-label>
        <textarea
          v-model="creationLoadingList"
          class="spl-input spl-consolidated-container__creator-loading-list" />
      </div>
      <div class="col2">
        <form-label />
        <form-button
          class="spl-next-button spl-consolidated-container__create-containers"
          @onClick="createContainers">
          Create Containers
        </form-button>
      </div>
    </div>
    <div
      v-for="(container, index) in bookingData.book_parcel_model.Container_Detail_List"
      :key="'consolidatedContainerDetailsAmount' + index"
      :class="'spl-consolidated-container__container-' + index"
      class="spl-consolidated-container__container">
      <h2>{{ getHeading(index) }}:</h2>
      <form-button
        v-if="bookingData.book_parcel_model.Container_Detail_List.length > 1"
        :class="'spl-consolidated-container__remove-container-' + index"
        @onClick="removeContainer(index)">
        Remove Container
      </form-button>
      <div class="row">
        <!-- *********************** Dimensions  *********************************** -->
        <!-- Only Required if no volume given-->
        <div class="col2">
          <form-label>Dimensions</form-label>
          <form-input
            v-model="container.Length"
            :invalid="$v.bookingData.book_parcel_model.Container_Detail_List[index].Length.$invalid"
            placeholder="Length (cm)"
            type="float"
            class="spl-consolidated-container__length" />
          <span v-if="!$v.bookingData.book_parcel_model.Container_Detail_List[index].Length.integer" class="error">Length has to be a number with no decimal places</span>
        </div>
        <div class="col2">
          <form-label />
          <form-input
            v-model="container.Width"
            :invalid="$v.bookingData.book_parcel_model.Container_Detail_List[index].Width.$invalid"
            placeholder="Width (cm)"
            type="float"
            class="spl-consolidated-container__width" />
          <span v-if="!$v.bookingData.book_parcel_model.Container_Detail_List[index].Width.integer" class="error">Width has to be a number with no decimal places</span>
        </div>
        <div class="col2">
          <form-label />
          <form-input
            v-model="container.Height"
            :invalid="$v.bookingData.book_parcel_model.Container_Detail_List[index].Height.$invalid"
            placeholder="Height (cm)"
            type="float"
            class="spl-consolidated-container__height" />
          <span v-if="!$v.bookingData.book_parcel_model.Container_Detail_List[index].Height.integer" class="error">Height has to be a number with no decimal places</span>
        </div>
        <!-- *************************** Security ***************************-->
        <div class="col3">
          <form-label>Security</form-label>
          <form-checkbox
            v-model="container.Dangerous_Goods"
            class="spl-consolidated-container__dangerous-good"
            @checkboxChanged="dangerous_goods_set">
            Dangerous Good
          </form-checkbox>
          <br>

          <form-checkbox class="spl-consolidated-container__xrayed" @checkboxChanged="xrayed_set">
            X-Rayed
          </form-checkbox>
          <br>
          <form-checkbox class="spl-consolidated-container__lmu" @checkboxChanged="lmu_set">
            Last Mile Upgrade
          </form-checkbox>
        </div>
      </div>
      <div class="row">
        <!-- *********************** Volume  *********************************** -->
        <!-- Only Required if no dimensions given-->
        <div class="col2">
          <form-label>Volume</form-label>
          <form-input
            v-model="container.Volume"
            :invalid="$v.bookingData.book_parcel_model.Container_Detail_List[index].Volume.$invalid"
            placeholder="Volume (m3)"
            type="float"
            class="spl-consolidated-container__volume" />
          <span v-if="!$v.bookingData.book_parcel_model.Container_Detail_List[index].Volume.decimal" class="error">Volume has to be a number</span>
        </div>

        <!-- *********************** Weight  *********************************** -->
        <div class="col2">
          <form-label>Weight</form-label>
          <form-input
            v-model="container.Weight"
            :required="true"
            :invalid="$v.bookingData.book_parcel_model.Container_Detail_List[index].Weight.$error"
            placeholder="Weight (kg)"
            type="float"
            class="spl-consolidated-container__weight"
            @blur="$v.bookingData.book_parcel_model.Container_Detail_List[index].Weight.$touch()" />
          <span v-if="!$v.bookingData.book_parcel_model.Container_Detail_List[index].Weight.decimal" class="error">Weight has to be a number</span>
          <span v-if="!$v.bookingData.book_parcel_model.Container_Detail_List[index].Weight.required" class="error">Weight is required</span>
          <span v-if="$v.bookingData.book_parcel_model.Container_Detail_List[index].Weight.$error && !$v.bookingData.book_parcel_model.Container_Detail_List[index].Weight.biggerThanZero" class="error">Weight has to be bigger than zero</span>
        </div>
      </div>
      <div class="row">
        <!-- *********************** Loading_List  *********************************** -->
        <div class="col12">
          <form-label>Loading List</form-label>
          <form-textarea
            v-model="container.Loading_List"
            :invalid="$v.bookingData.book_parcel_model.Container_Detail_List[index].Loading_List.$error"
            placeholder="Please add the loading list here"
            class="spl-consolidated-container__loading-list"
            @blur="$v.bookingData.book_parcel_model.Container_Detail_List[index].Loading_List.$touch()" />
        </div>
        <span
          v-if="$v.bookingData.book_parcel_model.Container_Detail_List[index].Loading_List.$error && !$v.bookingData.book_parcel_model.Container_Detail_List[index].Loading_List.required"
          class="error"
          style="margin-left: 10px;">A Loading List is required</span>
      </div>
    </div>
    <form-button
      class="spl-consolidated-container__add-container"
      @onClick="addContainer">
      Add Container
    </form-button>
    <!-- Next step footer -->
    <general-footer
      :cancel-visible="$mq === 'sm'"
      :positive-label="nextStepLabel"
      negative-label="Back"
      @negativeClicked="previousStep"
      @positiveClicked="nextStep" />
  </div>
</template>

<script>
import Helpers from '@/helpers.vue'
import { round } from 'lodash'
import { required, integer, decimal, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'ConsolidatedContainerDetails',
  mixins: [Helpers],
  props: ['bookingData', 'nextStepLabel'],
  data () {
    return {
      containerAmount: 0,
      creationNumContainers: 0,
      creationWeight: 0,
      creationVolume: 0,
      creationLoadingList: ''
    }
  },
  validations () {
    return {
      creationNumContainers: {
        integer
      },
      creationWeight: {
        decimal
      },
      creationVolume: {
        decimal
      },
      bookingData: {
        book_parcel_model: {
          Container_Detail_List: {
            ...this.containerValidations
          }
        }
      }
    }
  },
  computed: {
    containerValidations () {
      var validations = {}
      if (!this.bookingData.book_parcel_model || !this.bookingData.book_parcel_model.Container_Detail_List) {
        return validations
      }
      for (let i = 0; i < this.bookingData.book_parcel_model.Container_Detail_List.length; i++) {
        validations[i] = {
          Width: { integer },
          Height: { integer },
          Length: { integer },
          Volume: { decimal },
          Weight: {
            decimal,
            required,
            biggerThanZero (value) {
              if (isNaN(parseFloat(value))) {
                return true
              }
              return value > 0
            }
          },
          Loading_List: {
            required,
            minLength: minLength(1)
          }
        }
      }
      return validations
    }
  },
  mounted () {
    this.addContainer()
  },
  methods: {
    reset () {
      this.containerAmount = 0
      this.bookingData.book_parcel_model.Container_Detail_List = []
      this.$forceUpdate()
    },
    isValid () {
      return !this.$v.$invalid
    },
    createContainers () {
      // Create the containers by weight and volume
      this.containerAmount = this.creationNumContainers
      if (isNaN(this.containerAmount) || this.containerAmount < 1) {
        this.containerAmount = 1
      }
      this.bookingData.book_parcel_model.Container_Detail_List = []
      // calculate the weight for one container (200kg / 4 container = 50kg each)
      const singleWeight = round(this.creationWeight / this.containerAmount, 3)
      let singleVolume = 0
      // calculate the volume if applicable
      if (this.creationVolume > 0) {
        singleVolume = round(this.creationVolume / this.containerAmount, 6)
      }
      // create the container objects with prefilled data
      for (let i = 0; i < this.containerAmount; i++) {
        this.bookingData.book_parcel_model.Container_Detail_List.push({
          Weight: singleWeight,
          Volume: singleVolume,
          Length: 0,
          Width: 0,
          Height: 0,
          XRayed: false,
          Last_Mile_Upgrade: false,
          Dangerous_Goods: false,
          Loading_List: this.creationLoadingList
        })
      }
      // force update the component since it was not rendering correctly
      this.$forceUpdate()
    },
    addContainer () {
      // adds an empty container at the end of the list
      this.containerAmount++
      this.bookingData.book_parcel_model.Container_Detail_List.push({
        Weight: 0,
        Volume: 0,
        Length: 0,
        Width: 0,
        Height: 0,
        XRayed: false,
        Last_Mile_Upgrade: false,
        Dangerous_Goods: false,
        Loading_List: ''
      })
    },
    removeContainer (index) {
      // removes a container
      this.containerAmount--
      this.bookingData.book_parcel_model.Container_Detail_List.splice(index, 1)
      this.$forceUpdate()
    },
    // Set the dangerous goods
    dangerous_goods_set (item) {
      this.bookingData.book_parcel_model.Dangerous_Goods = item
    },

    // Set the xray
    xrayed_set (item) {
      this.bookingData.book_parcel_model.XRayed = item
    },

    // Set the last mile upgrade
    lmu_set (value) {
      this.bookingData.book_parcel_model.Last_Mile_Upgrade = value
    },

    // get the heading of the container (counter number + 00x)
    getHeading (index) {
      if (!this.bookingData.book_parcel_model) return ''
      var indexCount = '00' + (index + 1)
      return this.bookingData.book_parcel_model.Shipment_Reference + '_' + indexCount.substr(indexCount.length - 3)
    },
    nextStep () {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        this.$emit('nextStep', this.bookingData)
      }
    },
    previousStep () {
      this.$emit('previousStep', this.bookingData)
    }
  }
}
</script>

<style lang="scss">
.spl-consolidated-container {
  & .error {
    margin-bottom: 12px;
    margin-top: -10px;
  }
}
</style>
